module.exports = __webpack_public_path__ + "static/media/dec-snapshot-process@2x.ac4290bc.jpg";